export default __webpack_public_path__ + "static/media/carteirinha_2026.a878c998.png";